import cancelledIcon from '@assets/cancelled.svg';
import { SandboxMessageScreen } from '@/components/Sandbox/SandboxMessageScreen/SandboxMessageScreen';

export const SandboxCancelledScreen = ({
  redirectUrl,
}: {
  redirectUrl?: string;
}) => (
  <SandboxMessageScreen
    title="This verification has been cancelled"
    body="Thank you for letting us know that you don't recognize this verification attempt"
    icon={cancelledIcon}
  >
    {redirectUrl && (
      <a
        href={redirectUrl}
        style={{
          display: 'block',
          marginTop: '24px',
          color: 'white',
          textAlign: 'center',
        }}
      >
        Go to Sandbox
      </a>
    )}
  </SandboxMessageScreen>
);
